import { store } from '../app/store';

export function getRouteAccess(routeName) {
  const { profileData } = store.getState().fetchNavbar;

  if (!profileData || !profileData.department?.accessPages) return null;

  const route = profileData.department.accessPages.find(
    (page) => page.name === routeName,
  );

  return route || null;
}
